import React, { useState, useEffect } from 'react';
import Api from "../../../services/api";
import "../../../assets/css/app/monetization.css";
import { useNavigate, useParams } from "react-router-dom";
import moment from 'moment';
import { toast } from 'react-toastify';
import PaginationComponent from "../../../components/pagination";
import FilterCampaignCenter from "../../../components/filterCampaignCenter";
import { Spin } from "antd";

import { DndProvider, useDrag, useDrop } from 'react-dnd';
import { HTML5Backend } from 'react-dnd-html5-backend';
import { END_DATE, networkIcons, START_DATE } from '../../../utility';

const ItemTypes = {
    FIELD: 'field',
};

const FilterField = ({ field, index, moveField, toggleCheck }) => {
    const ref = React.useRef(null);
    const [, drop] = useDrop({
        accept: ItemTypes.FIELD,
        hover(item) {
            if (!ref.current) return;
            const dragIndex = item.index;
            const hoverIndex = index;
            if (dragIndex === hoverIndex) return;
            moveField(dragIndex, hoverIndex);
            item.index = hoverIndex;
        },
    });

    const [{ isDragging }, drag] = useDrag({
        type: ItemTypes.FIELD,
        item: { type: ItemTypes.FIELD, index },
        collect: (monitor) => ({
            isDragging: monitor.isDragging(),
        }),
    });

    drag(drop(ref));

    return (
        <div
            ref={ref}
            style={{
                opacity: isDragging ? 0.5 : 1,
                padding: '8px',
                background: '#f9f9f9',
                marginBottom: '4px',
                cursor: 'move',
                display: 'flex',
                alignItems: 'center',
                color: field.checked ? '#000' : '#aaa',
            }}
        >
            <input
                type="checkbox"
                checked={field.checked}
                onChange={() => toggleCheck(index)}
                style={{ marginRight: '10px' }}
            />
            {field.label}
        </div>
    );
};

function AppCampaignCenter(){
    const navigate = useNavigate();
    const [activeTab, setActiveTab] = useState('campaign');

    const [loading, setLoading] = useState(true);

    const [startDateTab1, setStartDateTab1] = useState(moment().subtract(START_DATE, 'days'));
    const [endDateTab1, setEndDateTab1] = useState(moment().subtract(END_DATE, 'days'));

    const [currentPage, setCurrentPage] = useState(1);
    const [totalPage, setTotalPage] = useState(4);

    const [data,setData] = useState([]);
    const [dataTotal,setDataTotal] = useState([]);

    const { code, os } = useParams();

    const [filterValuesTab1, setFilterValuesTab1] = useState(null);

    const [expandedGroups, setExpandedGroups] = useState({});

    const [showPopup, setShowPopup] = useState(false);
    const [fields, setFields] = useState([
        { key: 'media_source', label: 'Media source', checked: true },
        { key: 'campaign_id', label: 'Campaign', checked: true },
        { key: 'date', label: 'Date', checked: false },
        { key: 'ad_set_id', label: 'Ad Network', checked: false },
        { key: 'ad_group', label: 'Ad group', checked: false },
        { key: 'country', label: 'Country', checked: false },
    ]);

    const [selectCountry, setSelectCountry] = useState([]);

    const [sortConfig, setSortConfig] = useState({ field: null, direction: null });

    const toggleGroup = (mediaSource) => {
        setExpandedGroups((prev) => ({
            ...prev,
            [mediaSource]: !prev[mediaSource],
        }));
    };

    useEffect(() => {
        const searchParams = new URLSearchParams(window.location.search);
        const tabParam = searchParams.get('tab');
        if (tabParam && (tabParam === 'campaign' || tabParam === 'ad-group')) {
            setActiveTab(tabParam);
        }
    }, []);



    const fetchDataTab1 = (filters) => {
        setLoading(true);

        const cleanedDimensionFilters = (filters?.dimensionFilters || [])
            .filter(f => f.key && f.value && f.value.length > 0)
            .map(f => ({ key: f.key, operator: f.operator, value: f.value }));

        const cleanedMetricFilters = (filters?.metricFilters || [])
            .filter(f => f.key && (f.min !== '' || f.max !== ''));

        const params = {
            code: code,
            os: os,
            from: filters?.startDate?.format('YYYY-MM-DD') || startDateTab1.format('YYYY-MM-DD'),
            to: filters?.endDate?.format('YYYY-MM-DD') || endDateTab1.format('YYYY-MM-DD'),
            page: currentPage,
        };

        if (filters?.sortKeys?.length > 0) {
            params.sortKeys = filters.sortKeys;
        }

        if (cleanedDimensionFilters.length > 0 || cleanedMetricFilters.length > 0) {
            params.filters = JSON.stringify({
                dimensionFilters: cleanedDimensionFilters,
                metricFilters: cleanedMetricFilters
            });
        }


        Api.get(`/api/app/campaign_center`, { params })
            .then(result => {
                if (result.data.code === 0) {
                    setData(result.data.data);
                    setDataTotal(result.data.data_total);
                    setCurrentPage(result.data.page);
                    setTotalPage(result.data.total_page);
                } else {
                    toast.error("Lỗi lấy dữ liệu!!");
                }
                setLoading(false);
            })
            .catch(() => {
                setLoading(false);
                toast.error("Đã có lỗi xảy ra khi gọi API!");
            });
    };

    useEffect(() => {
        const fetchCountries = async () => {
            try {
                const response = await Api.get(
                    `/api/app/dimension_filter?dimension=country`
                );
                if (response?.data?.data) {
                    const options = Array.isArray(response.data.data)
                        ? response.data.data
                        : [];
                    setSelectCountry(options);
                }
            } catch (error) {
                console.error("Error fetching countries:", error);
            }
        };

        fetchCountries();
    }, []);


    useEffect(() => {
        fetchDataTab1(filterValuesTab1);
    }, [code, os, currentPage]);



    const handleRunReportTab1 = (filters) => {
        // Lọc ra các trường có thuộc tính 'checked' là true và lấy 'key' của chúng
        const selectedSortKeys = fields.filter((f) => f.checked).map((f) => f.key);

        const updatedFilters = {
            ...filters,
            sortKeys: selectedSortKeys,
        };

        setStartDateTab1(filters.startDate);
        setEndDateTab1(filters.endDate);
        setFilterValuesTab1(updatedFilters);
        fetchDataTab1(updatedFilters);
    };



    const handleChangePage = (page) => {
        setCurrentPage(page);
    }


    const formatNumber = (num) => num.toLocaleString("en-US", { minimumFractionDigits: 0, maximumFractionDigits: 2 });


    // Hàm định dạng số
    const formatNumber2 = (num) => {
        if (num === undefined || num === null) return '0';
        return num.toLocaleString();
    };


    const togglePopup = () => setShowPopup(!showPopup);

    const toggleCheck = (index) => {
        const newFields = [...fields];
        newFields[index].checked = !newFields[index].checked;
        setFields(newFields);
    };

    const moveField = (fromIndex, toIndex) => {
        const newFields = [...fields];
        const [movedItem] = newFields.splice(fromIndex, 1);
        newFields.splice(toIndex, 0, movedItem);
        setFields(newFields);
    };

    const handleDragEnd = () => {
        const selectedSortKeys = fields.filter((f) => f.checked).map((f) => f.key);

        const updatedFilters = {
            startDate: startDateTab1,
            endDate: endDateTab1,
            dimensionFilters: filterValuesTab1?.dimensionFilters || [], // Lấy các dimensionFilters hiện có
            metricFilters: filterValuesTab1?.metricFilters || [],       // Lấy các metricFilters hiện có
            sortKeys: selectedSortKeys, // Thêm các sortKeys mới
        };

        // Gọi lại hàm handleRunReportTab1 với đối tượng filters đã cập nhật
        handleRunReportTab1(updatedFilters);

        // Đóng popup sau khi đã gọi API
        setShowPopup(false);
    };

    const getGroupName = (item) => {
        if (item?.country) {
            const found = selectCountry.find(c => c.value === item.country);
            if (found) return found.label;
            return item.country;
        }
        
        return item.media_source || item.campaign_id || item.date || item.ad_set_id || item.ad_group || 'unknown';
    };

    const getImage = (item) => {
        if (item?.media_source && networkIcons[item.media_source]) {
            return (
                <img 
                    width="15px" 
                    height="15px" 
                    src={`/icon/${networkIcons[item.media_source]}`}
                    alt={item.media_source}
                    style={{ marginRight: '8px', borderRadius: "8px" }}
                />
            );
        }
        
        return '';
    };

    const toggleSort = (field) => {
        setSortConfig((prev) => {
            if (prev.field === field) {
                const newDirection = prev.direction === 'asc' ? 'desc' : 'asc';
                return { field, direction: newDirection };
            } else {
                return { field, direction: 'asc' };
            }
        });
    };

    const sortedData = React.useMemo(() => {
        if (!sortConfig.field) return data;

        const sortField = sortConfig.field;
        const direction = sortConfig.direction === 'asc' ? 1 : -1;

        const sortRecursive = (items) => {
            return [...items]
                .sort((a, b) => {
                    const aVal = parseFloat(a.totals?.[sortField]) || 0;
                    const bVal = parseFloat(b.totals?.[sortField]) || 0;
                    return aVal > bVal ? direction : aVal < bVal ? -direction : 0;
                })
                .map((item) => ({
                    ...item,
                    children: Array.isArray(item.children) ? sortRecursive(item.children) : [],
                }));
        };

        return sortRecursive(data);
    }, [data, sortConfig]);

    const renderGroup = (items, level = 0, parentKey = '') => {
        return items.map((item, index) => {
            const key = `${parentKey}-${index}`;
            const isExpanded = expandedGroups[key];
            const marginLeft = `${level * 20}px`;
            const hasChildren = Array.isArray(item.children) && item.children.length > 0;

            return (
                <React.Fragment key={key}>
                    <tr>
                        <td
                            className="sticky-col-left"
                            onClick={() => hasChildren && toggleGroup(key)}
                            colSpan="2"
                        >
                            <div className='d-flex align-items-center justify-content-between'>
                                <div className="d-flex align-items-center">
                                    {hasChildren ? (
                                        <i
                                            className={`fa-solid ${isExpanded ? 'fa-chevron-down' : 'fa-chevron-right'} toggle-icon2`}
                                            style={{ marginRight: '10px', fontSize: '10px', marginLeft }}
                                        ></i>
                                    ) : (
                                        <span style={{ marginLeft }}></span>
                                    )}
                                    {getGroupName(item)}
                                </div>
                                {getImage(item)}
                            </div>
                        </td>
                        <td className="text-center">${item.totals?.cost ? formatNumber(parseFloat(item.totals.cost)) : 0}</td>
                        <td className="text-center">{item.totals?.install_ad_network ? formatNumber(parseFloat(item.totals.install_ad_network)) : 0}</td>
                        <td className="text-center">{item.totals?.install_attributed ? formatNumber(parseFloat(item.totals.install_attributed)) : 0}</td>
                        <td className="text-center">${item.totals?.ecpi_ad_network ? formatNumber(parseFloat(item.totals.ecpi_ad_network)) : 0}</td>
                        <td className="text-center">${item.totals?.ecpi_attributed ? formatNumber(parseFloat(item.totals.ecpi_attributed)) : 0}</td>
                        {/*<td className="text-center">{item.totals?.roas_d0 ? formatNumber(parseFloat(item.totals.roas_d0)) : 0}</td>*/}
                        <td className="text-center">{item.totals?.RR_D1 ? formatNumber(parseFloat(item.totals.RR_D1)) : 0}%</td>
                        <td className="text-center">{item.totals?.RR_D3 ? formatNumber(parseFloat(item.totals.RR_D3)) : 0}%</td>
                        <td className="text-center">{item.totals?.RR_D7 ? formatNumber(parseFloat(item.totals.RR_D7)) : 0}%</td>
                        <td className="text-center">{item.totals?.RR_D14 ? formatNumber(parseFloat(item.totals.RR_D14)): 0}%</td>
                        <td className="text-center">${item.totals?.ad_revenue ? formatNumber(parseFloat(item.totals.ad_revenue)) : 0}</td>
                        <td className="text-center">${item.totals?.iap_revenue ? formatNumber(parseFloat(item.totals.iap_revenue)) : 0}</td>
                        {/*<td className="text-center">{item.totals?.count_session ? formatNumber(parseFloat(item.totals.count_session)) : 0}</td>*/}
                        <td className="text-center">{item.totals?.ipm ? formatNumber(parseFloat(item.totals.ipm)) : 0}</td>
                        <td className="text-center">{item.totals?.ecpm ? formatNumber(parseFloat(item.totals.ecpm)) : 0}</td>
                        <td className="text-center">{item.totals?.cti ? formatNumber(parseFloat(item.totals.cti)) : 0}%</td>
                        <td className="text-center">{item.totals?.count_impression ? formatNumber(parseFloat(item.totals.count_impression)) : 0}</td>
                        <td className="text-center">{item.totals?.count_clicks ? formatNumber(parseFloat(item.totals.count_clicks)) : 0}</td>
                        <td className="text-center">${item.totals?.ecpc ? formatNumber(parseFloat(item.totals.ecpc)) : 0}</td>
                        <td className="text-center">{item.totals?.daily_pu ? formatNumber(parseFloat(item.totals.daily_pu)) : 0}</td>
                        <td className="text-center">{item.totals?.paid_rate ? formatNumber(parseFloat(item.totals.paid_rate)): 0}%</td>

                        <td className="text-center">${item.totals?.total_ltv_0 ? formatNumber(parseFloat(item.totals.total_ltv_0)): 0}</td>
                        <td className="text-center">${item.totals?.total_ltv_1 ? formatNumber(parseFloat(item.totals.total_ltv_1)): 0}</td>
                        <td className="text-center">${item.totals?.total_ltv_3 ? formatNumber(parseFloat(item.totals.total_ltv_3)): 0}</td>
                        <td className="text-center">${item.totals?.total_ltv_7 ? formatNumber(parseFloat(item.totals.total_ltv_7)): 0}</td>
                        <td className="text-center">${item.totals?.total_ltv_14 ? formatNumber(parseFloat(item.totals.total_ltv_14)): 0}</td>

                        <td className="text-center">${item.totals?.ltv_iaa_1 ? formatNumber(parseFloat(item.totals.ltv_iaa_1)): 0}</td>
                        <td className="text-center">${item.totals?.ltv_iaa_3 ? formatNumber(parseFloat(item.totals.ltv_iaa_3)): 0}</td>
                        <td className="text-center">${item.totals?.ltv_iaa_7 ? formatNumber(parseFloat(item.totals.ltv_iaa_7)): 0}</td>
                        <td className="text-center">${item.totals?.ltv_iaa_14 ? formatNumber(parseFloat(item.totals.ltv_iaa_14)): 0}</td>

                        <td className="text-center">${item.totals?.ltv_iap_1 ? formatNumber(parseFloat(item.totals.ltv_iap_1)): 0}</td>
                        <td className="text-center">${item.totals?.ltv_iap_3 ? formatNumber(parseFloat(item.totals.ltv_iap_3)): 0}</td>
                        <td className="text-center">${item.totals?.ltv_iap_7 ? formatNumber(parseFloat(item.totals.ltv_iap_7)): 0}</td>
                        <td className="text-center">${item.totals?.ltv_iap_14 ? formatNumber(parseFloat(item.totals.ltv_iap_14)): 0}</td>

                        <td className="text-center">{item.totals?.ltv_roas_0 ? formatNumber(parseFloat(item.totals.ltv_roas_0)): 0}%</td>
                        <td className="text-center">{item.totals?.ltv_roas_1 ? formatNumber(parseFloat(item.totals.ltv_roas_1)): 0}%</td>
                        <td className="text-center">{item.totals?.ltv_roas_3 ? formatNumber(parseFloat(item.totals.ltv_roas_3)): 0}%</td>
                        <td className="text-center">{item.totals?.ltv_roas_7 ? formatNumber(parseFloat(item.totals.ltv_roas_7)): 0}%</td>
                        <td className="text-center">{item.totals?.ltv_roas_14 ? formatNumber(parseFloat(item.totals.ltv_roas_14)): 0}%</td>
                    </tr>

                    {isExpanded && hasChildren && renderGroup(item.children, level + 1, key)}
                </React.Fragment>
            );
        });
    };

    return (
    <>
        <section className="main__filter" >
            <div className="filter">
                <div className="container-fluid">
                    <form action="" method="get" id="form">
                        <div className="row justify-content-between align-items-center">
                            <div className="col-md-10">
                                <div className="title-head-box">
                                    <p className="title-block">Campaign Center</p>
                                </div>
                            </div>
                            <div className="col-md-2">

                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </section>

        <section className="main__content">
            <div className="container-fluid">

                <div className="tab-content" id="nav-tabContent">
                    <div className="tab-pane fade show active" id="nav-home" role="tabpanel"
                         aria-labelledby="nav-home-tab">
                        <div className="detail-body">
                            <div className="overview_content pd-20">
                                <div className="mt-4">
                                    <Spin spinning={loading} size="large">
                                        <FilterCampaignCenter
                                        startDate={startDateTab1}
                                        endDate={endDateTab1}
                                        handleChangeDate={(e, picker) => {
                                            setStartDateTab1(picker.startDate);
                                            setEndDateTab1(picker.endDate);
                                        }}
                                        id="filter-tab1"
                                        onRunReport={handleRunReportTab1}
                                    />
                                    <div className="table-wrapper">
                                        <div className="row">
                                            <div className="col-md-12 ">
                                                <button className="btn btn-outline-primary btn-sm" onClick={togglePopup} style={{ marginBottom: "10px", marginTop: "10px" }}>
                                                    <i className="fa fa-filter" /> Group item
                                                </button>

                                                {showPopup && (
                                                    <div style={{
                                                        position: 'absolute',
                                                        top: '44px',
                                                        left: '12px',
                                                        width: '250px',
                                                        border: '1px solid #ccc',
                                                        background: '#fff',
                                                        padding: '10px',
                                                        zIndex: 1000,
                                                        boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
                                                    }}>
                                                        <DndProvider backend={HTML5Backend}>
                                                            {fields.map((field, index) => (
                                                                <FilterField
                                                                    key={field.key}
                                                                    index={index}
                                                                    field={field}
                                                                    moveField={moveField}
                                                                    toggleCheck={toggleCheck}
                                                                />
                                                            ))}
                                                        </DndProvider>
                                                        <button className="btn btn-primary" onClick={handleDragEnd} style={{ marginTop: '10px' }}>Save</button>
                                                    </div>
                                                )}
                                            </div>
                                        </div>
                                        <div style={{ overflowX: 'auto' }}>
                                            <table className="table table-bordered table-hover tb-campaign-center" style={{ minWidth: '1000px', tableLayout: 'fixed' }}>
                                                <thead className="thead-light">
                                                <tr key="t-head1">
                                                    <th className="sticky-col-left" style={{ width: '400px' }} colSpan="2">
                                                        {fields
                                                            .filter((f) => f.checked)
                                                            .map((f, i, arr) => (
                                                                <span key={f.key} className="selected-label">
                                                                {f.label}
                                                                    {i < arr.length - 1 && <span className="comma">, </span>}
                                                                </span>
                                                            ))}
                                                    </th>
                                                    <th className="text-center" style={{ width: '150px' }} onClick={() => toggleSort('cost')}>Cost{' '}
                                                        <i
                                                            style={{ fontSize: "13px" }}
                                                            className={`fa-solid ${
                                                                sortConfig.field === 'cost'
                                                                    ? sortConfig.direction === 'asc'
                                                                        ? 'fa-arrow-up text-success'
                                                                        : 'fa-arrow-down text-success'
                                                                    : 'fa-arrow-up text-muted'
                                                            }`}
                                                        />
                                                    </th>
                                                    <th className="text-center" style={{ width: '150px' }}>Ad Network Installs</th>
                                                    <th className="text-center" style={{ width: '150px' }}>Attributed Installs</th>
                                                    {/*<th className="text-center" style={{ width: '150px' }}>SKAN Installs</th>*/}
                                                    <th className="text-center" style={{ width: '150px' }}>Ad Network eCPI</th>
                                                    <th className="text-center" style={{ width: '150px' }}>Attributed eCPI</th>

                                                    <th className="text-center" style={{ width: '150px' }}>RR D1</th>
                                                    <th className="text-center" style={{ width: '150px' }}>RR D3</th>
                                                    <th className="text-center" style={{ width: '150px' }}>RR D7</th>
                                                    <th className="text-center" style={{ width: '150px' }}>RR D14</th>

                                                    <th className="text-center" style={{ width: '150px' }}>Ad Revenue</th>
                                                    <th className="text-center" style={{ width: '150px' }}>IAP Revenue</th>
                                                    {/*<th className="text-center" style={{ width: '150px' }}>DAU</th>*/}
                                                    {/*<th className="text-center" style={{ width: '150px' }}>Play time</th>*/}
                                                    {/*<th className="text-center" style={{ width: '150px' }}>Sessions</th>*/}
                                                    <th className="text-center" style={{ width: '150px' }}>IPM</th>
                                                    <th className="text-center" style={{ width: '150px' }}>eCPM</th>
                                                    <th className="text-center" style={{ width: '150px' }}>CTI</th>
                                                    <th className="text-center" style={{ width: '150px' }}>Impressions</th>
                                                    {/*<th className="text-center" style={{ width: '150px' }}>CTR</th>*/}
                                                    <th className="text-center" style={{ width: '150px' }}>Clicks</th>
                                                    <th className="text-center" style={{ width: '150px' }}>eCPC</th>
                                                    {/*<th className="text-center" style={{ width: '150px' }}>RPDAU</th>*/}
                                                    {/*<th className="text-center" style={{ width: '150px' }}>IPDAU</th>*/}

                                                    {/*<th className="text-center" style={{ width: '150px' }}>RPM</th>*/}
                                                    <th className="text-center" style={{ width: '150px' }}>Daily Paid Users</th>
                                                    <th className="text-center" style={{ width: '150px' }}>Paid Rate</th>

                                                    <th className="text-center" style={{ width: '150px' }}>LTV D0</th>
                                                    <th className="text-center" style={{ width: '150px' }}>LTV D1</th>
                                                    <th className="text-center" style={{ width: '150px' }}>LTV D3</th>
                                                    <th className="text-center" style={{ width: '150px' }}>LTV D7</th>
                                                    <th className="text-center" style={{ width: '150px' }}>LTV D14</th>

                                                    <th className="text-center" style={{ width: '150px' }}>Ad LTV D1</th>
                                                    <th className="text-center" style={{ width: '150px' }}>Ad LTV D3</th>
                                                    <th className="text-center" style={{ width: '150px' }}>Ad LTV D7</th>
                                                    <th className="text-center" style={{ width: '150px' }}>Ad LTV D14</th>

                                                    <th className="text-center" style={{ width: '150px' }}>IAP LTV D1</th>
                                                    <th className="text-center" style={{ width: '150px' }}>IAP LTV D3</th>
                                                    <th className="text-center" style={{ width: '150px' }}>IAP LTV D7</th>
                                                    <th className="text-center" style={{ width: '150px' }}>IAP LTV D14</th>

                                                    <th className="text-center" style={{ width: '150px' }}>ROAS D0</th>
                                                    <th className="text-center" style={{ width: '150px' }}>ROAS D1</th>
                                                    <th className="text-center" style={{ width: '150px' }}>ROAS D3</th>
                                                    <th className="text-center" style={{ width: '150px' }}>ROAS D7</th>
                                                    <th className="text-center" style={{ width: '150px' }}>ROAS D14</th>
                                                </tr>
                                                </thead>
                                                <tbody>
                                                {sortedData.length > 0 ? (
                                                    renderGroup(sortedData)
                                                ) : (
                                                    <tr>
                                                        <td colSpan="16" className="text-center">
                                                            No data available
                                                        </td>
                                                    </tr>
                                                )}

                                                <tr className="table-secondary fw-bold" key="t-footer-1">
                                                    <td className='sticky-col-left' colSpan='2'>Total</td>
                                                    {/*<td className="text-center"></td>*/}
                                                    <td className="text-center">${dataTotal?.cost ? formatNumber(parseFloat(dataTotal.cost)) : 0}</td>
                                                    <td className="text-center">{dataTotal?.install_ad_network ? formatNumber(parseFloat(dataTotal.install_ad_network)) : 0}</td>
                                                    <td className="text-center">{dataTotal?.install_attributed ? formatNumber(parseFloat(dataTotal.install_attributed)) : 0}</td>
                                                    {/*<td className="text-center">0</td>*/}
                                                    <td className="text-center">${dataTotal?.ecpi_ad_network ? formatNumber(parseFloat(dataTotal.ecpi_ad_network)) : 0}</td>
                                                    <td className="text-center">${dataTotal?.ecpi_attributed ? formatNumber(parseFloat(dataTotal.ecpi_attributed)) : 0}</td>

                                                    <td className="text-center">{dataTotal?.RR_D1 ? formatNumber(parseFloat(dataTotal.RR_D1)) : 0}%</td>
                                                    <td className="text-center">{dataTotal?.RR_D3 ? formatNumber(parseFloat(dataTotal.RR_D3)) : 0}%</td>
                                                    <td className="text-center">{dataTotal?.RR_D7 ? formatNumber(parseFloat(dataTotal.RR_D7)) : 0}%</td>
                                                    <td className="text-center">{dataTotal?.RR_D14 ? formatNumber(parseFloat(dataTotal.RR_D14)) : 0}%</td>

                                                    {/*<td className="text-center">{dataTotal?.roas_d0 ? formatNumber(parseFloat(dataTotal.roas_d0)) : 0}</td>*/}

                                                    <td className="text-center">${dataTotal?.ad_revenue ? formatNumber(parseFloat(dataTotal.ad_revenue)) : 0}</td>
                                                    <td className="text-center">${dataTotal?.iap_revenue ? formatNumber(parseFloat(dataTotal.iap_revenue)) : 0}</td>
                                                    {/*<td className="text-center">0</td>*/}
                                                    {/*<td className="text-center">0</td>*/}
                                                    {/*<td className="text-center">{dataTotal?.count_session ? formatNumber(parseFloat(dataTotal.count_session)) : 0}</td>*/}
                                                    <td className="text-center">{dataTotal?.ipm ? formatNumber(parseFloat(dataTotal.ipm)) : 0}</td>
                                                    <td className="text-center">${dataTotal?.ecpm ? formatNumber(parseFloat(dataTotal.ecpm)) : 0}</td>
                                                    <td className="text-center">{dataTotal?.cti ? formatNumber(parseFloat(dataTotal.cti)) : 0}%</td>
                                                    {/*<td className="text-center">0%</td>*/}
                                                    <td className="text-center">{dataTotal?.count_impression ? formatNumber(parseFloat(dataTotal.count_impression)) : 0}</td>
                                                    {/*<td className="text-center">0%</td>*/}
                                                    <td className="text-center">{dataTotal?.count_clicks ? formatNumber(parseFloat(dataTotal.count_clicks)) : 0}</td>
                                                    <td className="text-center">${dataTotal?.ecpc ? formatNumber(parseFloat(dataTotal.ecpc)) : 0}</td>

                                                    <td className="text-center">{dataTotal?.daily_pu ? formatNumber(parseFloat(dataTotal.daily_pu)) : 0}</td>
                                                    <td className="text-center">{dataTotal?.paid_rate ? formatNumber(parseFloat(dataTotal.paid_rate)) : 0}%</td>

                                                    <td className="text-center">${dataTotal?.total_ltv_0 ? formatNumber(parseFloat(dataTotal.total_ltv_0)) : 0}</td>
                                                    <td className="text-center">${dataTotal?.total_ltv_1 ? formatNumber(parseFloat(dataTotal.total_ltv_1)) : 0}</td>
                                                    <td className="text-center">${dataTotal?.total_ltv_3 ? formatNumber(parseFloat(dataTotal.total_ltv_3)) : 0}</td>
                                                    <td className="text-center">${dataTotal?.total_ltv_7 ? formatNumber(parseFloat(dataTotal.total_ltv_7)) : 0}</td>
                                                    <td className="text-center">${dataTotal?.total_ltv_14 ? formatNumber(parseFloat(dataTotal.total_ltv_14)) : 0}</td>

                                                    <td className="text-center">${dataTotal?.ltv_iaa_1 ? formatNumber(parseFloat(dataTotal.ltv_iaa_1)) : 0}</td>
                                                    <td className="text-center">${dataTotal?.ltv_iaa_3 ? formatNumber(parseFloat(dataTotal.ltv_iaa_3)) : 0}</td>
                                                    <td className="text-center">${dataTotal?.ltv_iaa_7 ? formatNumber(parseFloat(dataTotal.ltv_iaa_7)) : 0}</td>
                                                    <td className="text-center">${dataTotal?.ltv_iaa_14 ? formatNumber(parseFloat(dataTotal.ltv_iaa_14)) : 0}</td>

                                                    <td className="text-center">${dataTotal?.ltv_iap_1 ? formatNumber(parseFloat(dataTotal.ltv_iap_1)) : 0}</td>
                                                    <td className="text-center">${dataTotal?.ltv_iap_3 ? formatNumber(parseFloat(dataTotal.ltv_iap_3)) : 0}</td>
                                                    <td className="text-center">${dataTotal?.ltv_iap_7 ? formatNumber(parseFloat(dataTotal.ltv_iap_7)) : 0}</td>
                                                    <td className="text-center">${dataTotal?.ltv_iap_14 ? formatNumber(parseFloat(dataTotal.ltv_iap_14)) : 0}</td>

                                                    <td className="text-center">{dataTotal?.ltv_roas_0 ? formatNumber(parseFloat(dataTotal.ltv_roas_0)) : 0}%</td>
                                                    <td className="text-center">{dataTotal?.ltv_roas_1 ? formatNumber(parseFloat(dataTotal.ltv_roas_1)) : 0}%</td>
                                                    <td className="text-center">{dataTotal?.ltv_roas_3 ? formatNumber(parseFloat(dataTotal.ltv_roas_3)) : 0}%</td>
                                                    <td className="text-center">{dataTotal?.ltv_roas_7 ? formatNumber(parseFloat(dataTotal.ltv_roas_7)) : 0}%</td>
                                                    <td className="text-center">{dataTotal?.ltv_roas_14 ? formatNumber(parseFloat(dataTotal.ltv_roas_14)) : 0}%</td>

                                                </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                    </Spin>
                                </div>
                            </div>
                        </div>
                        <PaginationComponent
                            current={currentPage}
                            total={totalPage}
                            handleChangePage={handleChangePage}
                        />
                    </div>
                </div>
            </div>
        </section>
    </>
    );
}
export default AppCampaignCenter;